import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { NotificationDefinition } from './notification-definition.entity';

export class CreateNotificationDefinitionDto extends Omit(NotificationDefinition, BaseEntityFieldsArray) {}
